import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {IceIceYetiGameModuleConfig} from "../../IceIceYetiGameModuleConfig";
import {IceIceYetiParsedGameData} from "../../server/data/IceIceYetiParsedGameData";

/**
 * Created by Jerker Nord on 2018-06-18.
 */

export class IceIceYetiStickyWildWPController extends WinPresentationController {

    private _removeWildsOnReel:boolean = false;
    private _previousGameMode:string = "";

    constructor(indexes:[number, number]) {
        super(indexes, {name : "IceIceYetiStickyWildWPController", skippable : false});
    }

    protected parseFeatureGameData(data:IceIceYetiParsedGameData):void {
        if(data.mode == GameMode.RESPIN && data.nextMode == GameMode.NORMAL) {
            this._removeWildsOnReel = true;
        }
        this._previousGameMode = data.mode;
    }

    protected hasWin():boolean {
        //Always true since we always want to check for sticky wilds to put back on reels
        return true;
    }

    protected startWinPresentation():void {
        if(this._removeWildsOnReel == true) {
            IceIceYetiGameModuleConfig.WildAttentionView.removeAllWilds();
            this._removeWildsOnReel = false;
        }
        this.finish();
    }

    protected stopWinPresentation(isAborted:boolean):void {
        //Todo: Do Abort?
    }
}